export default __webpack_public_path__ + "locales/el-GR/Settings.json?hash=23ab5d88f8a0d0da2e52f3ec5edc968a";